import type { ComentarioPesquisa, ItemPesquisa } from "../../../services/pesquisaSatisfacao"

export enum PesquisaSatisfacaoFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_INICIO = "ATUALIZAR_INICIO",
    ATUALIZAR_FIM = "ATUALIZAR_FIM",
}

export type PesquisaSatisfacaoFornecedorActionModel =
    | {
          type: PesquisaSatisfacaoFornecedorActionsTypes.CARREGAR
          payload: { itens: ItemPesquisa[]; comentarios: ComentarioPesquisa[]; total: number }
      }
    | { type: PesquisaSatisfacaoFornecedorActionsTypes.ATUALIZAR_INICIO; payload: number }
    | { type: PesquisaSatisfacaoFornecedorActionsTypes.ATUALIZAR_FIM; payload: number }
